// extracted by mini-css-extract-plugin
export default {"Button":"button_Button__gZA9e","Disabled":"button_Disabled__0IAkD"};